import React from "react";
import PostCard from "../postCard/PostCard";
import classNames from "classnames";
import {safeHTML} from "../../utils/safeHTML";
import {useRouter} from "next/router";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import styles from "./Recommendations.module.scss";


const Recommendations = React.forwardRef(
  function Recommendations({index, list, title = false, mod = "", backButton = false, showAnimation = false}, ref) {
    const router = useRouter();
    const items = list?.map((item, index) => {
      if (showAnimation) {
        return (
          <AppearSensor key={`item-${index}`} partialVisibility={true}>
            {({hasBeenVisible}) =>
              <PostCard
                {...item}
                color={false}
                tagsColor={true}
                type={"recommendations"}
                author={false}
                className={classNames(styles.recommendations__item, {
                  [styles.recommendations__item_show]: hasBeenVisible
                })}
                href={item.href}
                onClick={() => router.push(item.href)}
              />}
          </AppearSensor>
        )
      } else {
        return (
          <PostCard
            key={`item-${index}`}
            {...item}
            color={false}
            tagsColor={true}
            type={"recommendations"}
            author={false}
            className={classNames(styles.recommendations__item, styles.recommendations__item_show)}
            href={item.href}
            onClick={() => router.push(item.href)}
          />
        )
      }


    });
    return (
      <section className={classNames(styles.recommendations, {
        [styles[`recommendations_${index + 1}`]]:index + 1,
        [styles[`recommendations_${mod}`]]:mod
      })}
               ref={ref}>
        <div className={styles.recommendations__content}>
          {backButton && backButton}
          <AppearSensor partialVisibility={true}>
            {({hasBeenVisible}) => {
              if (title) {
                return (<h2 className={classNames(styles.recommendations__title, {
                  [styles.recommendations__title_show]: hasBeenVisible
                })}>{safeHTML(title)}</h2>)
              }
            }}
          </AppearSensor>
          <div className={styles.recommendations__list}>
            {items}
          </div>
        </div>

      </section>
    );
  });
export default Recommendations;
Recommendations.propTypes = {};

